import {CaretRight} from '@phosphor-icons/react'
import {useEffect, useState} from 'react'
import {useOccupancy} from '../../../hooks/useOccupancy'
import {LayoutModel} from '../../layout/models/layout.model'

const NodeTree = ({node, selectedOption, TipoDataIn}: any) => {
  const [isCampamentoExpanded, setIsCampamentoExpanded] = useState(false)
  // const [expandedModules, setExpandedModules] = useState<string[]>([])
  const {layoutData, getLayoutList, TipoData} = useOccupancy()

  const [nodeIn, setNodeIn] = useState<LayoutModel | any>({})

  const handleCampamentoExpand = () => {
    setIsCampamentoExpanded(!isCampamentoExpanded)

    if (!isCampamentoExpanded) {
      if (TipoDataIn === 'CAP') {
        loadModulesLayout()
      } else if (TipoDataIn === 'MOD') {
        loadPisosLayout()
      } else if (TipoDataIn === 'PIS') {
        loadHabitationsLayout()
      } else if (TipoDataIn === 'HAB') {
        loadCamasayout()
      }
    }
  }

  const loadModulesLayout = () => {
    getLayoutList({
      TipoData: 'MOD',
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: nodeIn.CampamentoId,
      //CampamentoId:campa.site,
    })
  }

  const loadPisosLayout = () => {
    getLayoutList({
      TipoData: 'PIS',
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: nodeIn.CampamentoId,
      ModuloId: nodeIn.ModuloId,
    })
  }

  const loadHabitationsLayout = () => {
    getLayoutList({
      TipoData: 'HAB',
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: nodeIn.CampamentoId,
      ModuloId: nodeIn.ModuloId,
      PisoId: nodeIn.PisoId,
    })
  }

  const loadCamasayout = () => {
    getLayoutList({
      TipoData: 'CAM',
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: nodeIn.CampamentoId,
      ModuloId: nodeIn.ModuloId,
      PisoId: nodeIn.PisoId,
      HabitacionId: nodeIn.HabitacionId,
    })
  }

  // const handleModuleToggle = (moduleId: string) => {
  //   console.log('moduleId', moduleId)
  //   const newExpandedModules = [...expandedModules]

  //   if (newExpandedModules.includes(moduleId)) {
  //     newExpandedModules.splice(newExpandedModules.indexOf(moduleId), 1)
  //   } else {
  //     newExpandedModules.push(moduleId)
  //   }

  //   setExpandedModules(newExpandedModules)
  // }

  useEffect(() => {
    if (!layoutData || layoutData.length === 0) return
    // if(TipoData === "CAP"){
    //     setNodeIn(layoutData)
    // }
    if (TipoData === 'MOD') {
      //setNodes(layoutData)
      setNodeIn({...nodeIn, modules: layoutData})
    }

    if (TipoData === 'PIS') {
      //setNodes(layoutData)
      setNodeIn({...nodeIn, pisos: layoutData})
    }

    if (TipoData === 'HAB') {
      //setNodes(layoutData)
      setNodeIn({...nodeIn, habitaciones: layoutData})
    }

    if (TipoData === 'CAM') {
      //setNodes(layoutData)
      setNodeIn({...nodeIn, camas: layoutData})
    }

    //console.log("new layoutData > ", layoutData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutData])

  useEffect(() => {
    // if (TipoDataIn === "CAP") {
    //setNodeIn(node)
    // }
    setNodeIn(node)
    // if(TipoDataIn === "MOD"){
    //     //setNodes(layoutData)
    //     setNodeIn({...nodeIn, "modulos":layoutData})
    // }
    console.log('TipoDataIn >>', TipoData)
    //console.log('TipoDataIn node >>', node)
    //console.log("new layoutData > ", layoutData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TipoDataIn])

  useEffect(() => {
    console.log('nodeIn >', nodeIn)
  }, [nodeIn])

  function getClassOpenTag() {
    if (TipoDataIn === 'MOD') {
      return 'btn-icon btn btn-active-light ms-1 me-1 w-30px h-30px rounded-circle p-0'
    } else if (TipoDataIn === 'PIS') {
      return 'btn-icon btn btn-active-light ms-3 me-3 w-30px h-30px rounded-circle p-0'
    } else if (TipoDataIn === 'HAB') {
      return 'btn-icon btn btn-active-light ms-5 me-5 w-30px h-30px rounded-circle p-0'
    } else if (TipoDataIn === 'CAM') {
      return 'btn-icon btn btn-active-light ms-7 me-7 invisible w-30px h-30px rounded-circle p-0'
    } else {
      return 'btn-icon btn btn-active-light me-1 w-30px h-30px rounded-circle p-0'
    }
  }
  return (
    <>
      <tr>
        <td>
          <button type='button' className={getClassOpenTag()} onClick={handleCampamentoExpand}>
            <CaretRight
              size={16}
              weight='bold'
              className={`${isCampamentoExpanded && 'animation-rotate-90'}`}
            />
          </button>

          <span className={`${isCampamentoExpanded && 'fw-bold'}`}>
            {TipoDataIn === 'CAP' && nodeIn.CampamentoNombre}
            {TipoDataIn === 'MOD' && nodeIn.NomenclaturaModulo}
            {TipoDataIn === 'PIS' && nodeIn.PisoNombre}
            {TipoDataIn === 'HAB' && nodeIn.NomenclaturaHabitacion}
            {TipoDataIn === 'CAM' && nodeIn.NomenclaturaCama}
          </span>
        </td>
        <td>{nodeIn.TotalModulos}</td>
        <td>{nodeIn.TotalHabitaciones}</td>
        <td className={'border-gray-200'}>{nodeIn.TotalCamas}</td>
        <td className={'border-gray-200'}>{nodeIn.TotalCamasCC}</td>
        <td className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
          {nodeIn.TotalCamas2}
        </td>
        <td>{nodeIn.TotalHabitacionesOCU}</td>
        <td>{nodeIn.TotalHabitacionesDIS}</td>
        <td>{nodeIn.TotalHabitacionesRES}</td>
        <td>{nodeIn.TotalHabitacionesBLO}</td>
        <td>{nodeIn.TotalCamasOCU}</td>
        <td>{nodeIn.TotalCamasDIS}</td>
        <td>{nodeIn.TotalCamasBLO}</td>
        <td className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
          {nodeIn.TotalCamasRES}
        </td>
        <td>{parseInt(String(Number(nodeIn.OcupacionHabitaciones) * 100))}%</td>
        <td>{parseInt(String(Number(nodeIn.OcupacionCamas) * 100))}%</td>
      </tr>
      {isCampamentoExpanded && nodeIn.modules && TipoDataIn === 'CAP' && (
        <>
          {nodeIn.modules.map((module: any) => (
            <>
              <NodeTree
                key={TipoDataIn + '-' + node.ModuloId}
                selectedOption={selectedOption}
                node={module}
                TipoDataIn={'MOD'}
              />
            </>
          ))}
        </>
      )}

      {isCampamentoExpanded && nodeIn.pisos && TipoDataIn === 'MOD' && (
        <>
          {nodeIn.pisos.map((piso: any) => (
            <>
              <NodeTree
                key={node.PisoId}
                selectedOption={selectedOption}
                node={piso}
                TipoDataIn={'PIS'}
              />
            </>
          ))}
        </>
      )}

      {isCampamentoExpanded && nodeIn.habitaciones && TipoDataIn === 'PIS' && (
        <>
          {nodeIn.habitaciones.map((habitacion: any) => (
            <>
              <NodeTree
                key={node.HabitacionId}
                selectedOption={selectedOption}
                node={habitacion}
                TipoDataIn={'HAB'}
              />
            </>
          ))}
        </>
      )}

      {isCampamentoExpanded && nodeIn.camas && TipoDataIn === 'HAB' && (
        <>
          {nodeIn.camas.map((cama: any) => (
            <>
              <NodeTree
                key={node.CamaId}
                selectedOption={selectedOption}
                node={cama}
                TipoDataIn={'CAM'}
              />
            </>
          ))}
        </>
      )}
    </>
  )
}

export const TableOccupancyManager = ({selectedOption}: any) => {
  // const [campsData, setCampsData] = useState<any>([])
  // const [loadingLayout, setLoadingLayout] = useState(false)
  const [lastDataType, setLastDataType] = useState('')
  const [nodes, setNodes] = useState([])
  const {layoutData, getLayoutList} = useOccupancy()
  console.log(nodes)
  const loadCampsLayout = () => {
    let TipoDataIn = 'CAP'
    setLastDataType(TipoDataIn)
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
    })
  }
  // const getLayoutList = async (Dto: any) => {
  //   setLoadingLayout(true)
  //   try {
  //     const response = await getList(Dto)
  //     let data = response.data.data
  //     setLayoutData(data)
  //     setIsLoading(false)
  //   } catch (error) {}
  // }

  useEffect(() => {
    if (!layoutData || layoutData.length === 0) return
    if (lastDataType === 'CAP') {
      setNodes(layoutData)
    }
    //console.log("new layoutData > ", layoutData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutData])

  useEffect(() => {
    if (!selectedOption.site) return
    loadCampsLayout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption.site])
  return (
    <div className='p-6'>
      <div className='card card-custom'>
        <div className='card-body'>
          <div className='table-responsive'>
            <table className='table gs-7 gy-7 gx-7 table-row-bordered table-hover'>
              <thead>
                <tr>
                  <th
                    rowSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{minWidth: '200px', borderRight: '1px solid black'}}
                  >
                    Nombre
                  </th>
                  <th
                    colSpan={5}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{borderRight: '1px solid black'}}
                  >
                    TOTALES
                  </th>
                  <th
                    colSpan={7}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{borderRight: '1px solid black'}}
                  >
                    DATOS
                  </th>
                  <th
                    colSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                  >
                    OCUPACIÓN
                  </th>
                </tr>
                <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                  <th>Módulos</th>
                  <th>Habitaciones</th>
                  <th style={{minWidth: '170px'}}>Camas Instaladas</th>
                  <th style={{minWidth: '160px'}}>Camas Calientes</th>
                  <th
                    className={'border-gray-200'}
                    style={{minWidth: '220px', borderRight: '1px solid black'}}
                  >
                    Camas Totales (C.I + C.C)
                  </th>

                  <th>Hbt. Ocupadas</th>
                  <th>Hbt. Disponibles</th>
                  <th>Hbt. Reservadas</th>
                  <th>Hbt. Bloqueadas</th>
                  <th>Camas Ocupadas</th>
                  <th>Camas Disponibles</th>
                  <th>Camas Bloqueadas</th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Camas Reservadas
                  </th>
                  <th>% Ocup. Hbt.</th>
                  <th>% Ocup. Camas</th>
                </tr>
              </thead>
              <tbody>
                {nodes.map((node: any) => (
                  <NodeTree
                    key={node.CampamentoId}
                    selectedOption={selectedOption}
                    node={node}
                    TipoDataIn={'CAP'}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
